export const BILLING_STATUSES = {
    BILLING_PENDING: 'Pending',
    BILLING_VALIDATED: 'Validated',
    BILLING_VERIFIED: 'Verified',
    BILLING_UPDATED: 'Updated',
    APPROVED_BY_PHYSICIAN: 'Physician Reviewed',
    CLAIM_SUBMITTED: 'Claim Submitted',
};
